import { jsxs as h, jsx as i } from "react/jsx-runtime";
import { E as f, S as v } from "./icons.types-0722eef5.js";
function p({ title: n, titleId: c, size: l, width: e, height: r, extended: t = !1, ...s }) {
  const o = t ? f : v, a = l ? o[l] : e || o[t ? "s" : "l"], d = l ? o[l] : r || o[t ? "s" : "l"];
  return /* @__PURE__ */ h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: a,
      height: d,
      "aria-labelledby": c,
      ...s,
      children: [
        n ? /* @__PURE__ */ i("title", { id: c, children: n }) : null,
        /* @__PURE__ */ i("g", { clipPath: "url(#Notification__Filled_svg__a)", children: /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M62.807 49.31c-1.508-1.565-5.91-5.225-5.91-19.782 0-8.894-5.18-16.453-12.576-19.774-.186-4.59-3.829-8.254-8.319-8.254-4.498 0-8.133 3.664-8.323 8.254-7.396 3.321-12.572 10.88-12.572 19.774 0 14.557-4.402 18.217-5.914 19.782a8.73 8.73 0 0 0-2.443 6.094v6.468h20.896c0 4.764 3.74 8.628 8.356 8.628s8.357-3.864 8.357-8.628H65.25v-6.468c0-2.378-.927-4.534-2.443-6.094Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "Notification__Filled_svg__a", children: /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as NotificationFilled
};
